const actionToast = document.getElementById("action-toast");
const actionToastProduct = document.getElementById(
  "action-toast-product"
);
const actionToastProductImage = document.getElementById(
  "action-toast-product-image"
);
const actionToastProductTitle = document.getElementById(
  "action-toast-product-title"
);
const actionToastProductOptions = document.getElementById(
  "action-toast-product-options"
);
const actionToastProductQuantity = document.getElementById(
  "action-toast-product-quantity"
);
let actionToastTimer;
let actionToastOnClick = null;

window.showActionToast = function ({
  message,
  shipmessage,
  product = null,
  reserveProductSpace = false,
  linkText = "",
  onClick = null,
  duration = 40000,
}) {
  console.log("toast");
  if (!actionToast) return;
  console.log("actiontoast");
  const actionToastMessage = document.getElementById(
    "action-toast-message"
  );
  const actionToastshipMessage = document.getElementById(
    "action-toast-shipmessage"
  );
  const actionToastLink = document.getElementById(
    "action-toast-link"
  );

  clearTimeout(actionToastTimer);

  actionToastMessage.textContent = message;
  actionToastshipMessage.innerHTML = shipmessage||"";
  actionToastOnClick = onClick;
 if (product) {
  actionToastProduct.hidden = false;
  actionToastProduct.classList.remove("is-placeholder");

  actionToastProductTitle.textContent = product.title || "";
  actionToastProductQuantity.textContent =
    `数量：${product.quantity || 1}`;

  if (product.image) {
    actionToastProductImage.src = product.image;
    actionToastProductImage.alt = product.title || "";
    actionToastProductImage.hidden = false;
  } else {
    actionToastProductImage.src = "";
    actionToastProductImage.alt = "";
    actionToastProductImage.hidden = true;
  }

  const optionText = (product.options || [])
    .filter((option) => {
      return (
        option.value &&
        option.value !== "Default Title"
      );
    })
    .map((option) => {
      return `${option.name}：${option.value}`;
    })
    .join(" / ");

  actionToastProductOptions.textContent = optionText;
  actionToastProductOptions.hidden = !optionText;

} else if (reserveProductSpace) {
  actionToastProduct.hidden = false;
  actionToastProduct.classList.add("is-placeholder");

  actionToastProductImage.src = "";
  actionToastProductImage.alt = "";
  actionToastProductImage.hidden = true;

  actionToastProductTitle.textContent = "";
  actionToastProductOptions.textContent = "";
  actionToastProductOptions.hidden = true;
  actionToastProductQuantity.textContent = "";

} else {
  actionToastProduct.hidden = true;
  actionToastProduct.classList.remove("is-placeholder");

  actionToastProductImage.src = "";
  actionToastProductImage.alt = "";
  actionToastProductImage.hidden = true;

  actionToastProductTitle.textContent = "";
  actionToastProductOptions.textContent = "";
  actionToastProductOptions.hidden = true;
  actionToastProductQuantity.textContent = "";
}
  if (linkText && typeof onClick === "function") {
    actionToastLink.textContent = linkText;
    actionToastLink.hidden = false;
  } else {
    actionToastLink.textContent = "";
    actionToastLink.hidden = true;
    actionToastOnClick = null;
  }

  actionToast.classList.add("is-show");
  actionToast.setAttribute("aria-hidden", "false");
  document.querySelector('.cart-item-count')?.style.setProperty('display', 'none');
  actionToastTimer = setTimeout(() => {
    closeActionToast();
  }, duration);
};

function closeActionToast() {
  clearTimeout(actionToastTimer);

  if (!actionToast) return;

  actionToast.classList.remove("is-show");
  actionToast.setAttribute("aria-hidden", "true");
}

document
  .getElementById("action-toast-close")
  ?.addEventListener("click", closeActionToast);

document
  .getElementById("action-toast-link")
  ?.addEventListener("click", () => {
    const callback = actionToastOnClick;

    closeActionToast();

    if (typeof callback === "function") {
      callback();
    }
  });